// extracted by mini-css-extract-plugin
export default {"menuSvg":"MenuLateral_menuSvg__fpBZo"};